import script from "./BodyPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyPhone.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodyPhone.vue?vue&type=style&index=0&id=e1ef3f0c&module=phone&lang=css"
cssModules["phone"] = style0
import "./BodyPhone.vue?vue&type=style&index=1&id=e1ef3f0c&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg});
